const TWO_PI = Math.PI * 2;

const randomBetween = ({ min, max }) => min + Math.random() * (max - min);

const makeWaves = (count, minimum, maximum, baseFrequency) =>
  Array.from({ length: count }, (_, index) => ({
    amplitude: randomBetween({ min: 0.6, max: 1.2 }),
    frequency: baseFrequency * (index + 1) * randomBetween({ min: 0.85, max: 1.15 }),
    phase: Math.random() * TWO_PI,
    minimum,
    maximum,
  }));

const waveValue = (waves, elapsed) =>
  waves.reduce((sum, wave) => sum + wave.amplitude * Math.sin(elapsed * wave.frequency + wave.phase), 0) /
  waves.reduce((sum, wave) => sum + wave.amplitude, 0);

const mapWaveToRange = (value, minimum, maximum) =>
  minimum + ((value + 1) / 2) * (maximum - minimum);

export default function createDriftBehavior(config) {
  const area = config.drift.area;
  const depth = config.drift.depth;
  const speed = config.drift.speed;
  const rotationAmplitude = config.drift.rotationAmplitude;
  const rotationSpeed = config.drift.rotationSpeed;
  const xWaves = makeWaves(3, area.x.min, area.x.max, 0.07);
  const yWaves = makeWaves(3, area.y.min, area.y.max, 0.09);
  const zWaves = makeWaves(3, depth.min, depth.max, 0.06);
  const yawWaves = makeWaves(2, -1, 1, 0.08);
  const pitchWaves = makeWaves(2, -1, 1, 0.11);
  const rollWaves = makeWaves(2, -1, 1, 0.13);
  const result = {
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
  };

  return {
    update(elapsed, _delta, viewport) {
      const x = mapWaveToRange(waveValue(xWaves, elapsed * (speed.x / 12)), area.x.min, area.x.max);
      const y = mapWaveToRange(waveValue(yWaves, elapsed * (speed.y / 8)), area.y.min, area.y.max);
      const z = mapWaveToRange(waveValue(zWaves, elapsed * (speed.z / 10)), depth.min, depth.max);

      result.position.x = x * viewport.width - viewport.width / 2;
      result.position.y = viewport.height / 2 - y * viewport.height;
      result.position.z = z;
      result.rotation.y = (rotationAmplitude.yaw * Math.PI / 180) * waveValue(yawWaves, elapsed * rotationSpeed);
      result.rotation.x = (rotationAmplitude.pitch * Math.PI / 180) * waveValue(pitchWaves, elapsed * rotationSpeed);
      result.rotation.z = (rotationAmplitude.roll * Math.PI / 180) * waveValue(rollWaves, elapsed * rotationSpeed);
      return result;
    },
  };
}
